import {
  OrderPaymentEvent,
  OrderPaymentProcessedEvent,
  OrderPaymentStatus,
} from '@oolio-group/domain';
import { useNavigation } from '@react-navigation/native';
import { useCallback } from 'react';
import { CARD_PAYMENT_TYPE } from '../../lib/constants';
import { ScreenName } from '../../lib/enums';

export const useCartNavigationHelper = () => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const navigation = useNavigation<any>();

  const navigateIdleScreen = useCallback(() => {
    navigation.navigateDeprecated(ScreenName.IDLE);
  }, [navigation]);

  const navigatePaymentScreen = useCallback(
    (event: OrderPaymentEvent) => {
      if (event.refundOrder) return;
      if (
        (event as OrderPaymentEvent).paymentTypeName.toLowerCase() !==
        CARD_PAYMENT_TYPE
      ) {
        navigation.navigateDeprecated(ScreenName.PAYMENT, {
          error: false,
          awaiting: false,
          changeDue: (event as OrderPaymentEvent).change,
          amount: (event as OrderPaymentEvent).tendered,
        });
      } else {
        navigation.navigateDeprecated(ScreenName.PAYMENT, {
          error: false,
          awaiting: true,
          amount: (event as OrderPaymentEvent).tendered,
        });
      }
    },
    [navigation],
  );

  const navigatePaymentResultScreen = useCallback(
    (event: OrderPaymentProcessedEvent, paymentRequestId: string) => {
      if (
        event.paymentStatus === OrderPaymentStatus.REJECTED ||
        event.paymentStatus === OrderPaymentStatus.CANCELLED
      ) {
        navigation.navigateDeprecated(ScreenName.PAYMENT, {
          error: true,
          awaiting: false,
          paymentRequestId: paymentRequestId,
        });
      } else if (event.paymentStatus === OrderPaymentStatus.COMPLETE) {
        navigation.navigateDeprecated(ScreenName.PAYMENT, {
          error: false,
          awaiting: false,
          paymentRequestId: paymentRequestId,
        });
      }
    },
    [navigation],
  );

  const navigateCartScreen = useCallback(() => {
    navigation.navigateDeprecated(ScreenName.CART);
  }, [navigation]);

  const navigateSendReceiptScreen = useCallback(() => {
    navigation.navigateDeprecated(ScreenName.SEND_RECEIPT);
  }, [navigation]);

  return {
    navigateIdleScreen,
    navigatePaymentScreen,
    navigateCartScreen,
    navigatePaymentResultScreen,
    navigateSendReceiptScreen,
  };
};
